import ModalUtil from 'common/util/ModalUtil';
import MaskUtil from 'common/util/MaskUtil';
import {node_observable_component} from 'common/util/ComponentDecorator';

@node_observable_component
export default class orderForm {
    static classname = 'order-form-decorator';
    #orderForm = $();
    #decorator = $();
    #orderFormSelector = '#js-order-form'
    #decoratorSelector = '.order-form-decorator';
    #decoratorClassReady = 'order-form-decorator_ready';

    constructor($decorator) {
        this.#decorator = $decorator;
        this.#orderForm = $decorator.find(this.#orderFormSelector);
        this.changeOrderFormFunctions();
        this.decorate();
        this.initEventListener();
    }

    initEventListener() {
        $(document).on('set_discount', (e, discount) => {
            this.setDiscount();
        })

        this.#orderForm.on('input', '.wa-input', (e) => this.checkValidOptional($(e.currentTarget)));

        this.#orderForm.on('wa_order_form_changed', (event, data) => {
            this.decorate();

            let $zip_field = this.#orderForm.find('.js-zip-field');
            $zip_field.closest('.wa-zip-wrapper').toggle(!$zip_field.val());
        });

        this.#orderForm.on('click', '.wa-login-link', function (e) {
            e.preventDefault();
            const $form = $($('#index-modal-login-template').prop('content').cloneNode(true));
            ModalUtil.openContent($form, function () {
                Update($form.parent());
            });
        });

        this.#orderForm.on('wa_order_form_confirm_changed', function (that) {
            let cart = window.waOrder.cart;

            $.post(cart.urls['save'], cart.getCartData(), 'json').done(function (response) {
                if (response.status !== 'ok') {
                    return;
                }

                let api = formatAPI(response.data);
                cart.updateCart(api);
                cart.trigger('rendered', api);
            });

            function formatAPI(api) {
                var result = api;

                if (result.errors) {
                    if (result.errors.items) {
                        $.each(result.errors.items, function (item_id, errors) {
                            if (result.cart.items && result.cart.items[item_id]) {
                                result.cart.items[item_id]['errors'] = errors;
                            }
                        });
                    }
                }

                return result;
            }
        });

        this.observeData(this.#orderForm, ($elm) => {
            if (!$elm.hasClass('wa-input')) {
                return;
            }

            this.checkValidOptional($elm);
        });

        window.ObserverUtil.observe('ymaps-geolink', () => {
            if (this.#orderForm.find('.pick-up-info').length) {
                return;
            }

            const $pickUpInfoItems = this.#orderForm.find('.wa-schedule-wrapper, ' +
                '.wa-comment-item, .wa-additional-item');

            if (!$pickUpInfoItems.length) {
                return;
            }

            const $pickUpInfo = $('<span class="order-form-decorator__pick-up-info pick-up-info">' +
                '<span class="pick-up-info__icon">i</span>' +
                '<span class="pick-up-info__text">Адрес и режим работы</span>' +
                '</span>');

            const $pickUpInfoContent = $('<div class="pick-up-info__content"></div>')
            $('.wa-details-rates-section .wa-table').after($pickUpInfoContent);
            $pickUpInfoContent.append($pickUpInfoItems);
            $pickUpInfoContent.before($pickUpInfo);

            $pickUpInfo.on('click', (e) => {
                e.preventDefault();
                $pickUpInfoContent.slideToggle(300);
            });
        })

        window.ObserverUtil.observe('js-methods-list', ($node) => {
            $node.on('click', 'a', (e) => {
                e.stopPropagation();
            })
        })
    }

    decorate() {
        this.#decorator.removeClass(this.#decoratorClassReady);
        this.decorateInputs();
        this.decorateSelect();
        this.decorateProfileLink();
        this.setDiscount();
        this.setCheckedCheckbox();
        this.#decorator.addClass(this.#decoratorClassReady);
    }

    decorateInputs() {
        const $inputs = this.#orderForm.find('.wa-input');
        $inputs.each((ind, input) => {
            const $input = $(input);
            $input.prop('placeholder', $input.prev('.wa-label').text());
            this.checkValidOptional($input);

            if ($input.hasClass('wa-phone')) {
                MaskUtil.initIntlTelMask($input);
            }
        });
    }

    decorateSelect() {
        this.#orderForm.find('select').each(function () {
            const $select = $(this);
            const $selectFieldBlock = $select.closest('.field');
            const $selectLabelBlock = $selectFieldBlock.find('.custom-label');
            const selectLabel = $selectLabelBlock.text();
            let classes = '';

            if ($select.attr('name') === 'region[country]') {
                const availableCountries = ['rus', 'blr', 'kaz'];
                $select.find('option').each(function () {
                    const $option = $(this);
                    const index = availableCountries.indexOf($option.val());

                    if (index !== -1) {
                        availableCountries.splice(index, 1);
                        return;
                    }

                    $option.remove()
                })

                classes += ' select_countries'
            }

            Select.create($select, '', true, classes, selectLabel, $select.attr('name') === 'region[region]');
        })
    }

    decorateProfileLink() {
        const $section = this.#orderForm.find('.wa-section-header');
        const $loginLink = $section.find('.wa-login-link')

        if ($loginLink.length) {
            $loginLink.removeClass('js-show-login-dialog');
        } else {
            $section.find('.wa-contact-name').wrap('<a class="link" href="/my/profile/" target="_blank"></a>')
        }
    }

    setCheckedCheckbox() {
        this.#orderForm.find('.is-agreement-field .wa-checkbox').prop('checked', true);
    }

    checkValidOptional($input) {
        if ($input.prop('required')) {
            return;
        }

        const val = $input.val();
        const isValid = val.length > 0 && val !== '0' && $input.get(0).checkValidity()

        if (isValid) {
            $input.addClass('valid');
        } else {
            $input.removeClass('valid');
        }
    }

    observeData($elements, callback, options = {attributes: true, subtree: true}) {
        function mutationCallback(mutationsList) {
            mutationsList.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName.startsWith('data-')) {
                    callback($(mutation.target))
                }
            });
        }

        const observer = new MutationObserver(mutationCallback);

        $elements.each(function () {
            observer.observe(this, options);
        })
    }

    setDiscount() {
        const $discount = this.#orderForm.find('.wa-item-discount');
        const discount = window.discount;

        if (discount === undefined) {
            $discount.remove()
            return;
        }

        if ($discount.length) {
            $discount.find('.wa-price').html(discount);
        } else {
            const $itemPrice = this.#orderForm.find('.wa-item-price');
            const $discountClone = $itemPrice.clone();
            $discountClone.removeClass('wa-item-price').addClass('wa-item-discount');
            $discountClone.find('.wa-price').html(discount);
            $discountClone.find('.wa-name').text('Скидка');
            $itemPrice.after($discountClone);
        }
    }

    changeOrderFormFunctions() {
        const $waOrderFormWrapper = this.#orderForm.find('#wa-order-form-wrapper');

        if (!$waOrderFormWrapper.length) {
            return;
        }

        $waOrderFormWrapper.find('.js-city-autocomplete').removeClass('js-city-autocomplete');


        $waOrderFormWrapper.data('ready').promise().then(function (form) {
            const initRegion = form.initRegion;
            form.initRegion = (function () {
                $waOrderFormWrapper.find('.js-city-autocomplete').removeClass('js-city-autocomplete');
                const $section = $waOrderFormWrapper.find('#wa-step-region-section')
                initRegion.bind(form)({$wrapper: $section, disabled: false, auto_use_timeout: 3000, errors: []});
            }).bind(form);


            window.waOrder.ui.Dialog = function (options) {
                const that = this;

                that.$wrapper = options.$wrapper;
                that.$wrapper.data('dialog', that);
                that.position = (options['position'] || false);
                that.userPosition = (options['setPosition'] || false);
                that.options = (options['options'] || false);
                that.scroll_locked_class = 'is-scroll-locked';
                that.height_limit = (options['height_limit'] || 640);
                that.onBgClick = (options['onBgClick'] || false);
                that.onOpen = (options['onOpen'] || function () {
                });
                that.onClose = (options['onClose'] || function () {
                });
                that.onResize = (options['onResize'] || false);

                that.lock = function () {

                };

                that.resize = function () {

                };

                that.close = function (closeAll) {
                    if (typeof closeAll === 'undefined' && that.$wrapper.hasClass('wa-auth-dialog-wrapper')) {
                        closeAll = false;
                    } else if (typeof closeAll === 'undefined') {
                        closeAll = true;
                    }

                    ModalUtil.close(closeAll);
                };

                var modalClasses = ['order-modal'];
                var $wrapper = $('<div class="order-ui-decorator order-dialog-decorator"></div>');
                $wrapper.append(options.$wrapper);

                $wrapper.find('.js-cancel, .js-close-dialog').on('click', () => {
                    that.close(true);
                });

                $wrapper.find('.js-confirm').on('click', function () {
                    $(document).trigger('confirm_modal');
                })

                $wrapper.find('.wa-login-form-wrapper').each(function () {
                    modalClasses.push('order-modal_auth');
                    $wrapper.addClass('form-decorator login-page login-modal')
                        .data('form_size', 's')
                        .data('field_size', 's');
                });
                $wrapper.find('.wa-forgotpassword-form-wrapper').each(function () {
                    modalClasses.push(' order-modal_auth');
                    $wrapper.addClass('forgotpassword-page forgotpassword-modal')
                        .wrapInner('<div class="forgotpassword-page__form-decorator" data-size="s" data-field_size="s"></div>');
                });
                $wrapper.find('.wa-signup-form-wrapper').each(function () {
                    modalClasses.push('order-modal_auth');
                    $wrapper.addClass('form-decorator signup-page signup-modal')
                        .data('form_size', 's')
                        .data('field_size', 's');
                });
                $wrapper.find('.wa-confirm-dialog').each(function () {
                    modalClasses.push('order-modal_confirm');
                    $wrapper.addClass('order-confirm-modal');
                });
                $wrapper.find('.wa-channel-confirmation-dialog').each(function () {
                    modalClasses.push('order-modal_confirmation');
                    $wrapper.addClass('form-decorator order-confirm-modal order-confirm-modal_order-page')
                        .data('form_size', 's')
                        .data('field_size', 's');
                });
                $wrapper.find('.wa-product-edit-dialog').each(function () {
                    modalClasses.push('order-modal_product-edit');
                    $wrapper.addClass('order-product-edit-modal');
                });

                var onOpen = function () {
                    if (typeof that.onOpen === 'function') {
                        that.onOpen(that.$wrapper, that);
                    }

                    $('#wa-content-frontend-login-css, #wa-content-signup-css, #wa-content-frontend-forgotpassword-css, #wa-content-jquery-ui-js, #wa-content-jquery-ui-css').each(function () {
                        var $this = $(this);
                        $this.data('promise').then(function () {
                            $this.remove();
                        });
                    });
                };

                var onClose = function () {
                    if (typeof that.onClose === 'function') {
                        that.onClose(that);
                    }
                };

                ModalUtil.openContent($wrapper, {
                        classes: modalClasses.join(' '),
                        beforeOpen: function ($modal) {
                            $modal.find('.modal__close').remove();
                        },
                        onOpen: onOpen,
                        onClose: onClose
                    }
                );
            };
        })
    }
}